import React from "react";

const LandingPageAverageMilesItem = ({ fidelity } = props) => {
	const splittedValue = String((fidelity.price7DaysAgo * 10).toFixed(2)).split(".");

	const getSourceLink = name => {
		switch (name) {
			case "TudoAzul":
				return "https://www.maxmilhas.com.br/vender-milhas/azul-tudoazul?utm_source=ofertantes&utm_medium=lptf";
			case "Multiplus / Gold":
			case "Latam Pass":
			case "Multiplus":
				return "https://www.maxmilhas.com.br/vender-milhas/latam-multiplus?utm_source=ofertantes&utm_medium=lptf";
			case "Smiles":
				return "https://www.maxmilhas.com.br/vender-milhas/gol-smiles?utm_source=ofertantes&utm_medium=lptf";
			default:
				return "#";
		}
	};

	return (
		<div className="offers-landing-page-average-miles-item">
			<div className="offers-landing-page-average-miles-item__card">
				<div className="offers-landing-page-average-miles-item__card__header">{`${
					fidelity.name
				} | ${fidelity.airline || "-"}`}</div>
				<div className="offers-landing-page-average-miles-item__card__content">
					<strong>10.000 MILHAS</strong>
					<span>=</span>
					<div className="offers-landing-page-average-miles-item__card__content--value">
						<strong className="offers-landing-page-average-miles-item__card__content--value--currency">
							R$
						</strong>
						<h4 className="offers-landing-page-average-miles-item__card__content--value--integral-value">
							{splittedValue[0]}
						</h4>
						<h5 className="offers-landing-page-average-miles-item__card__content--value--decimal-value">
							,
							{splittedValue[1] || "00"}
						</h5>
					</div>
					<small>{fidelity.name == "Amigo" ? `(média semanal)` : "\u00A0"}</small>
				</div>
			</div>
			<a className="btn-green-md-s" target="_blank" href={getSourceLink(fidelity.name)}>
				QUERO VENDER
			</a>
		</div>
	);
};

export default LandingPageAverageMilesItem;
